"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _events = _interopRequireDefault(require("events"));

var _flow = _interopRequireDefault(require("./flow"));

var _operations = require("./operations");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Selection =
/*#__PURE__*/
function (_Emitter) {
  _inherits(Selection, _Emitter);

  function Selection(iterable) {
    var _this;

    _classCallCheck(this, Selection);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Selection).call(this));
    /* eslint-disable no-console */

    console.warn('DEPRECATION warning: The imperative interface of ' + 'yourchoice is deprecated and will be removed in yourchoice 3.0.0');
    /* eslint-enable no-console */

    _this.iterable = iterable;
    _this.state = (0, _operations.init)();

    _this._updateSelectedItems();

    return _this;
  }

  _createClass(Selection, [{
    key: "toggle",
    value: function toggle(item) {
      this.state = (0, _flow.default)((0, _operations.setItems)(this.iterable), (0, _operations.toggle)(item))(this.state);

      this._updateSelectedItems();

      this._notifyChangedItems();

      this._emitChangeEvent();
    }
  }, {
    key: "replace",
    value: function replace(item) {
      this.state = (0, _flow.default)((0, _operations.setItems)(this.iterable), (0, _operations.replace)(item))(this.state);

      this._updateSelectedItems();

      this._notifyChangedItems();

      this._emitChangeEvent();
    }
  }, {
    key: "remove",
    value: function remove(items) {
      this.state = (0, _flow.default)((0, _operations.setItems)(this.iterable), (0, _operations.remove)(items))(this.state);

      this._updateSelectedItems();

      this._notifyChangedItems();

      this._emitChangeEvent();
    }
  }, {
    key: "removeAll",
    value: function removeAll() {
      this.state = (0, _flow.default)((0, _operations.setItems)(this.iterable), (0, _operations.removeAll)())(this.state);

      this._updateSelectedItems();

      this._notifyChangedItems();

      this._emitChangeEvent();
    }
  }, {
    key: "rangeTo",
    value: function rangeTo(endItem) {
      this.state = (0, _flow.default)((0, _operations.setItems)(this.iterable), (0, _operations.rangeTo)(endItem))(this.state);

      this._updateSelectedItems();

      this._notifyChangedItems();

      this._emitChangeEvent();
    }
  }, {
    key: "_updateSelectedItems",
    value: function _updateSelectedItems() {
      this.selectedItems = (0, _operations.getSelection)(this.state);
    }
  }, {
    key: "_notifyChangedItems",
    value: function _notifyChangedItems() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _operations.getChangedSelection)(this.state)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;
          item.select();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _operations.getChangedDeselection)(this.state)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _item = _step2.value;

          _item.deselect();
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }, {
    key: "_emitChangeEvent",
    value: function _emitChangeEvent() {
      var change = (0, _operations.getChangedSelection)(this.state).length > 0 || (0, _operations.getChangedDeselection)(this.state).length > 0;

      if (change) {
        this.emit('change', this.selectedItems.slice());
      }
    }
  }]);

  return Selection;
}(_events.default);

var _default = Selection;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/yourchoice/lib/selection.js
// module id = 160
// module chunks = 0